// 2024.08.30 邓智轩：针对俄罗斯游戏关闭默认选中上次支付渠道功能（测试新渠道的使用情况）
// 后续开启可删除此文件和对应的引用
// 需要隐藏上次支付方式的游戏id
export const hideLastPayWayGameIds = [285, 191, 269, 295, 263, 339, 175, 331];
export const isHideLastPayWay = (gameId, location) => {
  return hideLastPayWayGameIds.includes(+gameId) && location === 'RU';
};
